// reacttour/TourKeyboardControls.js

export const setupTourKeyboardControls = ({
  currentStep,
  stepsLength,
  setCurrentStep,
  setIsOpen,
}) => {
  const handleKey = (e) => {
    if (e.key === "ArrowRight") {
      // Next step
      if (currentStep < stepsLength - 1) {
        setCurrentStep(currentStep + 1);
      }
    }

    if (e.key === "ArrowLeft") {
      // Previous step
      if (currentStep > 0) {
        setCurrentStep(currentStep - 1);
      }
    }

    if (e.key === "Escape") {
      // Close tour
      setIsOpen(false);
    }
  };

  window.addEventListener("keydown", handleKey);

  // ✅ Cleanup when component unmounts
  return () => window.removeEventListener("keydown", handleKey);
};
